import React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import {
  ORDER_SERVICE_TYPE_LABELS,
  type OrderServiceType,
} from '@constants/orderServiceType';
import './OrderServiceTypeToggle.scss';

interface OrderServiceTypeToggleProps {
  value: OrderServiceType;
  onChange: (value: OrderServiceType) => void;
  className?: string;
  compact?: boolean;
}

export default function OrderServiceTypeToggle({
  value,
  onChange,
  className = '',
  compact = true,
}: OrderServiceTypeToggleProps) {
  const handleChange = (_event: React.MouseEvent<HTMLElement>, next: OrderServiceType | null) => {
    if (next) {
      onChange(next);
    }
  };

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={handleChange}
      className={`order-service-type-toggle${compact ? ' order-service-type-toggle--compact' : ''} ${className}`.trim()}
      aria-label="Order service type"
    >
      <ToggleButton value="dine-in" aria-label="Dine-in">
        {ORDER_SERVICE_TYPE_LABELS['dine-in']}
      </ToggleButton>
      <ToggleButton value="takeaway" aria-label="Takeaway">
        {ORDER_SERVICE_TYPE_LABELS.takeaway}
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
